import type { FaireProductEntity } from "../../entity_types/product";

export const p_ar35uaktm3: FaireProductEntity = {
  token: "p_ar35uaktm3",
  type: "product",
  name: "Handblown Etched Long Stemmed Cocktail Glass - Clear",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/b5a3c72d848d9086b3bf40a10eea50600f631099e3fdb9ce98115225a30838b6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b6b33d30dfa04f1f68d94ccccb15984af297b37c74fd414e405892ad9a5ff82.jpeg",
    "https://cdn.faire.com/fastly/0ec071898591d0f07c222e38bdc264db45fa150bca6b5c87df653ff8e8b50830.jpeg",
    "https://cdn.faire.com/fastly/10991f796888cc5d9bf364a87b5a7af6116b3f8a8ebbf30e6ebaa2740986c8e8.jpeg",
    "https://cdn.faire.com/fastly/754fdcb828dc3a4dbeefbc7df7cc4eabb4abb87ecfa04bba29de33e5e7c3fc3b.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "**Packaged in sets of 2 as shown; sold as 8 single glasses in a master (4 boxes of 2 glasses). Price shown is per glass.**\n\nHandblown and hand-etched in Mexico, this long-stemmed cocktail glass combines artisan craftsmanship with refined elegance. Its delicate etched detailing adds a timeless touch, perfect for serving martinis, spritzes, or your favorite signature cocktails. Each piece is one-of-a-kind and made to elevate any occasion.\n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nDimensions: 7.2'' height x 4.2'' diameter, 10 oz. capacity (due to the handblown nature, variances may occur). ",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:23.849Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
